import Schedule from '../../Actions/schedule'
const { types } = Schedule

const initialState = {
    scheduleRequest: {
        lapseDays: '2',
        taxId: '',
        documentType: '0',
        active: 1,
        frequencyInDays: '7',
        processType:'0',
        generatePdf: false,
        googleDrive: false,
        includeCancellationDate: false,
        cfdiStatus: 'Todos',
        cfdiType: null,
        cfdiComplement: null
    },
    scheduleConfigs:{records:[]},
    schedulePagination:{
        page: 1,
        pageCount: 1,
        perPage: 10,
        totalCount: 10
    },
    // Filtros de la tabla de configuraciones (null = no aplica)
    scheduleFilters: {
        taxIds: [],
        documentType: null,
        processType: null,
        frequencyInDays: null,
        cfdiType: null,
        cfdiComplement: null,
        active: null
    }
}


const scheduleReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_SCHEDULE_PROPERTY:
            return {
                ...state,
                scheduleRequest: {
                    ...state.scheduleRequest,
                    ...action.data
                }
            };
        case types.SET_SCHEDULE_RECORDS:
            return{
                ...state,
                scheduleConfigs:{
                    records:action.records   
                }
            }
        case types.SET_SCHEDULE_FILTERS:
            return {
                ...state,
                scheduleFilters:{
                    ...state.scheduleFilters,
                    ...action.filters
                }
            }
        case types.SET_SCHEDULE_PAGINATION:
            return {
                ...state,
                schedulePagination:{
                    ...state.schedulePagination,
                    ...action.pagination
                }
            }
        case types.SET_SCHEDULE_STATUS:
                let { row } = action.data
                let newConfigs = Object.assign([], state.scheduleConfigs.records, {index: row});
            return{
                ...state,
                scheduleConfigs:{
                    records:newConfigs
                }
            }
        default:
            return state;
    }
}

export default scheduleReducer